module.exports = __webpack_public_path__ + "static/media/abstract1.b4a9787f.jpg";